import React from 'react';

const LoadingModal = ({ isLoading, title = 'Generating Research Report', message = 'This may take a few moments...' }) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[100] p-4 modal-fade-in">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full shadow-2xl modal-slide-up">
        <div className="text-center">
          {/* Animated Spinner */}
          <div className="flex justify-center mb-6">
            <div className="relative w-20 h-20">
              {/* Outer rotating ring */}
              <div className="absolute inset-0 border-4 border-[#78350F]/20 rounded-full"></div>
              <div className="absolute inset-0 border-4 border-transparent border-t-[#78350F] rounded-full animate-spin"></div>
              
              {/* Inner pulsing circle */}
              <div className="absolute inset-2 bg-[#78350F]/10 rounded-full animate-pulse"></div>
              <div className="absolute inset-4 bg-[#78350F]/20 rounded-full animate-ping"></div>
            </div>
          </div>

          {/* Loading Text */}
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            {title}
          </h2>
          <p className="text-gray-600 mb-4">
            {message}
          </p>

          {/* Progress Dots */}
          <div className="flex justify-center gap-2 mt-6">
            <div className="w-2 h-2 bg-[#78350F] rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
            <div className="w-2 h-2 bg-[#78350F] rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
            <div className="w-2 h-2 bg-[#78350F] rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingModal;

